export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Payments.json?hash=268e73031e95b6dc4b203cd6c92acb9e";